exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeviceDetailsPage .DebounceInputFilter label {\r\n  text-transform: uppercase;\r\n  font-size: 16px;\r\n}\r\n\r\n.DeviceDetailsPage .three-columns .report {\r\n  width: 311px;\r\n}\r\n\r\n.DeviceDetailsPage .report h2 {\r\n  white-space: initial;\r\n}\r\n\r\n.DeviceDetailsPage .SimpleTimeRangeFilter select, .DeviceDetailsPage .SimpleTimeRangeFilter label {\r\n  font-size: 16px;\r\n}\r\n\r\n", ""]);

// exports
